<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'ESTRUCTURAFISICA.LBL_INFOESTRUCTURA' | translate}}">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{estFisica.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{estFisica.estructuraFisica}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_DIRECCION' | translate }}:</label>
          <label class="lg:col-9 col-6 md:col-8"><strong>{{estFisica.direccion}}</strong></label>
        </div>
      </p-panel>
    </div>
  </div>
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fEjecutivos" name="fEjecutivos">
    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'ESTRUCTURAFISICA.LBL_EJECUTIVO' | translate }}</label>
          <p-dropdown disableTab  id="idEjecutivo" name="nomEjecutivo" [options]="lisEjecutivos" filter="filter"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" required="true"
                       formControlName="idTercero"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTercero.invalid">
            {{ 'ESTRUCTURAFISICA.LBL_EJECUTIVO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'ESTRUCTURAFISICA.LBL_ZONA' | translate }}</label>
          <p-dropdown disableTab  id="idZona" name="nomZona" [options]="lisZonas" filter="filter"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" required="true"
                       formControlName="idZona"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idZona.invalid">
            {{ 'ESTRUCTURAFISICA.LBL_ZONA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="lisEjecutivosZonas"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.tercero}}</td>
            <td>{{row.zona}}</td>
            <td>{{row.secundariasTexto }}</td>
            <td class="text-center">
              <div class="btn-group" role="group"  *ngIf="!validandoIndicador">
                <button type="button" class="p-button btn" icon="fa fa-plus" data-toggle="tooltip"
                        title="{{'ESTRUCTURAFISICA.BTN_AGREGARZONA' | translate}}"
                        pButton (click)="agregarZona(row)"></button>
                <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'ESTRUCTURAFISICA.BTN_DESVINCULARZONA' | translate}}"
                        pButton (click)="desvincularZona(row)"></button>
              </div>
              <div class="grid" *ngIf="validandoIndicador">
                <div class="col-12 md:col-12 lg:col-12 text-center">
                  <i class="fa fa-refresh fa-spin fa-fw"></i>
                  <span>{{ 'LBL_VALIDANDO' | translate}}...</span>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>

<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [(visible)]="mostrarDialogo"
          header="{{ (indDesvincular ? 'ESTRUCTURAFISICA.LBL_DESVINCULAR' : 'ESTRUCTURAFISICA.LBL_ASIGNARZONA') | translate}}"
          [modal]="true"
          class="overflow-y-unset">
  <div class="grid" *ngIf="carInformacionDialogo">
    <div class="col-12 md:col-12 lg:col-12 text-center">
      <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
      <span>{{'LBL_PROCESANDO' | translate }}</span>
    </div>
  </div>

  <div class="grid form-group" *ngIf="!carInformacionDialogo">
    <div class="col-12 md:col-12 lg:col-12">
      <p>{{ (indDesvincular ? 'ESTRUCTURAFISICA.MSG_DESVINCULAR' : 'ESTRUCTURAFISICA.MSG_ASIGNARZONA') | translate }} {{ejeSeleccionado ? ejeSeleccionado.tercero : ''}}</p>
      <form [formGroup]="forZonas" (ngSubmit)="asignarEjecutivos()" novalidate id="fAsignarEjecutivos" name="fAsignarEjecutivos">
        <div class="grid form-group" *ngIf="indDesvincular">
          <div class="col-12 md:col-6 lg:col-6" *ngIf="lisZonasSecundarias.length>0">
            <div class="div-form">
              <p-checkbox label="{{ 'ESTRUCTURAFISICA.LBL_TODASZONAS' | translate}}" binary="true"
                          id="indTodasZonas"
                          name="nomTodasZonas"
                          formControlName="indicadorTodasZonas"></p-checkbox>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-6" *ngIf="!fSecundarias.indicadorTodasZonas.value && ejeSeleccionado && ejeSeleccionado.idZona">
            <div class="div-form">
              <p-checkbox label="{{ 'ESTRUCTURAFISICA.LBL_ZONAPRINCIPAL' | translate}}" binary="true"
                          id="indZonaPrincipal"
                          name="nomZonaPrincipal"
                          formControlName="indicadorZonaPrincipal"></p-checkbox>
            </div>
          </div>
        </div>
        <div class="grid form-group" *ngIf="(!fSecundarias.indicadorTodasZonas.value && lisZonasSecundarias.length>0) || !indDesvincular">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label>* {{ 'ESTRUCTURAFISICA.LBL_ZONA' | translate }}</label>
              <p-multiSelect id="idZonas" name="nomZonas" [options]="lisZonasSecundarias" filter="filter"
                             defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                             selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idZonas"
                             emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             optionValue="value"
                             optionLabel="label"
              ></p-multiSelect>
              <div class="p-message p-messages-error p-corner-all" *ngIf="subZonas && fSecundarias.idZonas.invalid">
                {{ 'ESTRUCTURAFISICA.MSG_ZONAREQUERIDA' | translate}}
              </div>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <div *ngIf="!guaZonas">
              <a (click)="regZonas(forZonas.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
              <button icon="fa fa-plus"
                      label="{{(indDesvincular ? 'ESTRUCTURAFISICA.BTN_DESVINCULARZONA' : 'ESTRUCTURAFISICA.BTN_AGREGARADICIONAL') | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guaZonas">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
